<template>
  <!-- 充放电看板 bulletinBoard-->
  <div class="bulletinBoard" :id="idFlag?'kanban':''">
    <div class="icons">
      <img src="@/page/projectDingZhi/yuenan/params/22.png" v-if="fullscreen" @click="handleFullScreen">
      <img src="@/page/projectDingZhi/yuenan/params/11.png" v-else @click="handleFullScreen">
      <img src="@/page/projectDingZhi/yuenan/params/home.png" @click="idFlag = !idFlag">
    </div>
    <div class="span" style="display: flex;margin-bottom: 10px;">
      <div class="box" style="height: 250px;margin-right: 10px;">
        <div class="tit">近一月累计净收益(万元)</div>
        <div class="icon_box">
          <div class="li">
            <img class="img" src="../../assets/bulletinBoard/1.png">
            <div class="num">97.73</div>
            <div class="name">净收益</div>
          </div>
          <div class="li">
            <img class="img" src="../../assets/bulletinBoard/2.png">
            <div class="num" style="color: #368ed9;">97.73</div>
            <div class="name">充电成本</div>
          </div>
          <div class="li">
            <img class="img" src="../../assets/bulletinBoard/3.png">
            <div class="num" style="color: #25b0a8;">97.73</div>
            <div class="name">放电收益</div>
          </div>
        </div>
      </div>
      <div class="box" style="flex: 1;">
        <div class="tit">基本情况</div>
        <div class="all_box">
          <div class="text_box">
            <div class="li">
              <div class="name">电站额定功率</div>
              <div class="num">0</div>
              <div class="unit">MW</div>
            </div>
            <div class="li">
              <div class="name">最大可充功率</div>
              <div class="num">0</div>
              <div class="unit">MW</div>
            </div>
            <div class="li">
              <div class="name">最大可放功率</div>
              <div class="num">0</div>
              <div class="unit">MW</div>
            </div>
            <div class="li">
              <div class="name">储能总功率</div>
              <div class="num">0</div>
              <div class="unit">MW</div>
            </div>
          </div>
          <div class="text_box">
            <div class="li">
              <div class="name">电站额定容量</div>
              <div class="num">0</div>
              <div class="unit">MWh</div>
            </div>
            <div class="li">
              <div class="name">当前可充容量</div>
              <div class="num">0</div>
              <div class="unit">MWh</div>
            </div>
            <div class="li">
              <div class="name">当前可放容量</div>
              <div class="num">0</div>
              <div class="unit">MWh</div>
            </div>
            <div class="li">
              <div class="name">电站储能PCS运行</div>
              <div class="num">0</div>
              <div class="unit">台</div>
            </div>

          </div>
          <div class="text_box">
            <div class="li">
              <div class="name">日充电量</div>
              <div class="num">0</div>
              <div class="unit">MWh</div>
            </div>
            <div class="li">
              <div class="name">日放电量</div>
              <div class="num">0</div>
              <div class="unit">MWh</div>
            </div>
            <div class="li">
              <div class="name">电池健康状态SOH</div>
              <div class="num">0</div>
              <div class="unit">%</div>
            </div>
            <div class="li">
              <div class="name">剩余SOC</div>
              <div class="num">0</div>
              <div class="unit">%</div>
            </div>

          </div>
        </div>
      </div>
    </div>
    <div class="span" style="display: flex;margin-bottom: 10px;">
      <div class="box" style="height: 270px;margin-right: 10px;">
        <div class="tit">运行总览</div>
        <div class="infos">已安全运行 100 天</div>
        <div class="zonglan">
          <div class="li">
            <div class="img">
              <img src="../../assets/bulletinBoard/4.png" alt="">
              <div class="n">PCS运行台数</div>
            </div>
            <div class="num">97</div>
            <div class="uni">台</div>
          </div>
          <div class="li">
            <div class="img">
              <img src="../../assets/bulletinBoard/5.png" alt="">
              <div class="n">总充电量</div>
            </div>
            <div class="num">97.73</div>
            <div class="uni">MWh</div>
          </div>
          <div class="li">
            <div class="img">
              <img src="../../assets/bulletinBoard/6.png" alt="">
              <div class="n">总SOC</div>
            </div>
            <div class="num">97.7</div>
            <div class="uni">%</div>
          </div>
          <div class="li">
            <div class="img">
              <img src="../../assets/bulletinBoard/7.png" alt="">
              <div class="n">总放电量</div>
            </div>
            <div class="num">97.73</div>
            <div class="uni">MWh</div>
          </div>
        </div>
      </div>
      <div class="box" style="flex: 1;">
        <div class="tit">总充放功率日曲线</div>
        <div class="titles">
          <div class="p">总充电功率 <div class="span">97.73</div>MWh</div>
          <div class="p">总放电功率 <div class="span">97.73</div>MWh</div>
        </div>
        <vchart class="vcharted" ref='vchart1'></vchart>
      </div>
    </div>
    <div class="box" style="height: calc(100vh - 565px);width: 100%;">
      <div class="tit">近一月累计收益分析</div>
      <vchart class="vcharted" ref='vchart2'></vchart>
    </div>
  </div>
</template>

<script>
  import vchart from '@/components/module/chart/vchart.vue'
  export default {
    components: {
      vchart
    },
    data () {
      return {
        fullscreen: false,
        idFlag: false,
      }
    },

    mounted () {
      this.yonghu();
      this.yonghu2();
    },
    methods: {
      // 全屏事件
      handleFullScreen () {
        // 此处可根据获取节点进行区域全屏事件
        console.log(111);
        let element=document.getElementsByClassName('bulletinBoard')[0];
        if(this.fullscreen) {
          if(document.exitFullscreen) {
            document.exitFullscreen();
          } else if(document.webkitCancelFullScreen) {
            document.webkitCancelFullScreen();
          } else if(document.mozCancelFullScreen) {
            document.mozCancelFullScreen();
          } else if(document.msExitFullscreen) {
            document.msExitFullscreen();
          }
        } else {
          if(element.requestFullscreen) {
            element.requestFullscreen();
          } else if(element.webkitRequestFullScreen) {
            element.webkitRequestFullScreen();
          } else if(element.mozRequestFullScreen) {
            element.mozRequestFullScreen();
          } else if(element.msRequestFullscreen) {
            // IE11
            element.msRequestFullscreen();
          }
        }
        this.fullscreen=!this.fullscreen;
      },
      // 月出货量
      yonghu2 () {
        var d=[]
        for(let i=1;i<25;i++) {
          d.push(i)
        }


        var option={
          tooltip: {
            trigger: 'axis',
          },
          xAxis: {
            type: 'category',
            data: d,
            splitLine: {
              show: false,
              lineStyle: {
                color: 'rgba(0, 240, 255, 0.3)'
              }
            },
            axisLabel: {
              show: true,
              textStyle: {
                color: '#fff',
                fontSize: 9
              }
            }
          },
          yAxis: {
            type: 'value',
            splitLine: {
              show: true,
              lineStyle: {
                type: 'dashed'
              }
            },
            //文字
            axisLabel: {
              color: '#fff'
            }
          },
          legend: {
            textStyle: {
              fontSize: 12,//字体大小
              color: '#ccc'//字体颜色
            },
            top: 23,
            right: 25,
            icon: "circle",   //  这个字段控制形状  类型包括 circle，rect ，roundRect，triangle，diamond，pin，arrow，none
            itemWidth: 10,  // 设置宽度 
            itemHeight: 10, // 设置高度
          },
          grid: {
            top: 70,
            bottom: '5%',
            left: '2%',
            right: '3%',
            containLabel: true
          },
          color: ['#368ED9','#25B0A8','#d6c339'], //柱子颜色

          series: [
            {
              name: '充电成本',
              data: [0.10,0.14,0.12,0.19,0.31,0.52,0.68,0.45,0.65,0.54,0.23,0.36],

              type: 'bar',
              smooth: true
            },
            {
              name: '放电收益',
              data: [0.30,0.54,0.62,0.39,0.61,0.72,0.38,0.65,0.85,0.54,0.73,0.26],
              type: 'bar',
              smooth: true
            },{
              name: '净收益',
              data: [1.30,2.54,3.62,0.39,0.61,0.72,0.38,0.65,0.85,0.54,0.73,0.26],
              type: 'bar',
              smooth: true
            },
          ]

        }

        this.$refs.vchart2.setData(option,true);
      },
      // 月出货量
      yonghu () {
        var d=[]
        for(let i=1;i<25;i++) {
          d.push(i)
        }


        var option={
          tooltip: {
            trigger: 'axis',
          },
          xAxis: {
            type: 'category',
            boundaryGap: false,
            data: d,
            splitLine: {
              show: false,
              lineStyle: {
                color: 'rgba(0, 240, 255, 0.3)'
              }
            },
            axisLabel: {
              show: true,
              textStyle: {
                color: '#fff',
                fontSize: 9
              }
            }
          },
          yAxis: {
            type: 'value',
            boundaryGap: false,
            splitLine: {
              show: true,
              lineStyle: {
                type: 'dashed'
              }
            },
            //文字
            axisLabel: {
              color: '#fff'
            }
          },
          legend: {
            textStyle: {
              fontSize: 12,//字体大小
              color: '#ccc'//字体颜色
            },
            top: 23,
            right: 25,
            icon: "circle",   //  这个字段控制形状  类型包括 circle，rect ，roundRect，triangle，diamond，pin，arrow，none
            itemWidth: 10,  // 设置宽度 
            itemHeight: 10, // 设置高度
          },
          grid: {
            top: 70,
            bottom: '5%',
            left: '2%',
            right: '3%',
            containLabel: true
          },
          color: ['#368ED9','#25B0A8','#cb8429'], //柱子颜色

          series: [
            {
              name: '充电功率',
              data: [0.10,0.14,0.12,0.19,0.31,0.52,0.68,0.45,0.65,0.54,0.23,0.36],

              type: 'line',
              symbol: 'none', //去掉折线图中的节点
              smooth: true
            },
            {
              name: '放电功率',
              data: [0.30,0.54,0.62,0.39,0.61,0.72,0.38,0.65,0.85,0.54,0.73,0.26],


              type: 'line',
              symbol: 'none', //去掉折线图中的节点
              smooth: true
            },
          ]

        }

        this.$refs.vchart1.setData(option,true);
      },
    }
  };
</script>

<style lang="scss" scoped>
  #kanban {
    width: 100%;
    position: fixed;
    top: 0;
    margin: 0;
    left: 0;
    right: 0;
    bottom: 0;
    height: 100% !important;
    z-index: 10;
  }

  .icons {
    position: absolute;
    right: 10px;
    top: 24px;
    z-index: 11;
  }

  .icons img {
    margin-left: 15px;
  }

  .titles {
    position: absolute;
    top: 20px;
    width: 100%;
    text-align: center;
    display: flex;
    justify-content: center;
    color: #fff;
    z-index: 10;
  }

  .titles .p {
    display: flex;
    align-items: center;
    margin-right: 40px;
  }

  .titles .p .span {
    color: #368ED9;
    font-weight: bold;
    font-size: 16px;
    margin-left: 15px;
    margin-right: 5px;
  }

  .vcharted {
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 9;
  }

  .infos {
    position: absolute;
    right: 20px;
    top: 22px;
    color: #368ED9;
    font-size: 13px;
  }

  .zonglan {
    width: 445px;
    display: flex;
    flex-wrap: wrap;
    margin-top: 10px;
  }

  .zonglan .li .uni {
    font-size: 14px;
  }

  .zonglan .li .num {
    font-size: 24px;
    color: #368ED9;
    margin-right: 5px;
  }

  .zonglan .li .img {
    margin-right: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 88px;
  }

  .zonglan .li .img .n {
    font-size: 14px;
    width: 100%;
    text-align: center;
  }

  .zonglan .li {
    width: 50%;
    box-sizing: border-box;
    display: flex;
    color: #fff;
    align-items: center;
    padding: 0 15px;
    height: 100px;
  }

  .all_box {
    margin-top: 25px;
  }

  .all_box .text_box .li .name {
    width: 130px;
    text-align: right;
  }

  .all_box .text_box .li .num {
    text-align: center;
    color: #368ED9;
  }

  .all_box .text_box .li .unit {
    width: 85px;
  }

  .all_box .text_box .li {
    display: flex;
    justify-content: space-between;
    margin-bottom: 21px;
  }

  .all_box .text_box {
    display: flex;
    flex-direction: column;
    width: 33%;
    border-left: 1px solid #368ED966;
  }

  .all_box .text_box:nth-child(1) {
    border-left: none;
  }

  .all_box .text_box:nth-child(1) .li .name {
    width: 100px;
  }

  .all_box .text_box:nth-child(3) .li .unit {
    width: 50px;
  }

  .all_box .text_box:nth-child(3) .li .name {
    width: 150px;
  }

  .all_box .text_box:nth-child(2) .li .name {
    width: 150px;
  }


  .all_box {
    display: flex;
  }

  .box {
    display: inline-block;
    box-sizing: border-box;
    background: rgba(129, 197, 255, 0.25);
    padding: 15px;
    padding-top: 20px;
    position: relative;
  }

  .box .icon_box {
    display: flex;
    margin-top: 30px;
    width: 500px;
    justify-content: space-around;
  }

  .box .icon_box .li .name {
    color: #fff;
    font-size: 14px;
  }

  .box .icon_box .li .num {
    color: #D6C339;
    font-size: 32px;
  }

  .box .icon_box .li {
    display: flex;
    flex-direction: column;
    align-items: center;

  }

  .box .tit {
    display: inline-block;
    font-size: 16px;
    border-bottom: 2px solid #368ED9;
  }

  .bulletinBoard {
    background: url('../../../public/static/image/dekan/denken.png');
    /* background-color: #304156; */
    background-size: 100% 100%;
    color: #fff;
    box-sizing: border-box;
    padding: 10px !important;
    overflow-x: hidden;
    position: relative;
  }
</style>